import MESSAGES from 'core/data-model/constants/bi-messages'
import Mustache from 'mustache'

export const legalDisclaimerSection = ({ startDate, endDate }) => ({
  stack: [
    { text: MESSAGES.LEGAL_DISCLAIMER, style: 'title' },
    {
      ol: [
        [
          {
            text: MESSAGES.POLICY_MAY_CHANGE,
          },
          {
            separator: ['1.'],
            ol: [MESSAGES.AGE_HEALTH_OR_CAREER, MESSAGES.INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT],
          },
        ],
        MESSAGES.PRELIMINARY_OFFER_MAY_CHANGE,
        Mustache.render(MESSAGES.OFFER_SALE_PERIOD, {
          startOffer: startDate,
          endOffer: endDate,
        }),
      ],
    },
  ],
  style: 'groupRow',
})

export const legalDisclaimerTwoSection = ({ startDate, endDate, isBancAgent }) => ({
  stack: [
    { text: MESSAGES.LEGAL_DISCLAIMER, style: 'title' },
    {
      ol: [
        [
          {
            text: MESSAGES.POLICY_MAY_CHANGE,
          },
          {
            separator: ['1.'],
            ol: [
              MESSAGES.AGE_HEALTH_OR_CAREER,
              Mustache.render(MESSAGES.FLEXI_HEALTH_INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT, {
                agentName: isBancAgent ? MESSAGES.FLEXI_HEALTH_BANC : MESSAGES.FLEXI_HEALTH_AGENT,
              }),
            ],
          },
        ],
        MESSAGES.PRELIMINARY_OFFER_MAY_CHANGE,
        Mustache.render(MESSAGES.FLEXI_HEALTH_OFFER_SALE_PERIOD, {
          startOffer: startDate,
          endOffer: endDate,
        }),
      ],
    },
  ],
  style: 'groupRow',
})

export const legalDisclaimerThreeSection = ({ startDate, endDate }) => ({
  stack: [
    { text: MESSAGES.LEGAL_DISCLAIMER, style: 'title' },
    {
      ol: [
        [
          {
            text: MESSAGES.POLICY_MAY_CHANGE,
          },
          {
            separator: ['1.'],
            ol: [MESSAGES.AGE_HEALTH_OR_CAREER, MESSAGES.INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT_DETAIL],
          },
        ],
        MESSAGES.PRELIMINARY_OFFER_MAY_CHANGE,
        Mustache.render(MESSAGES.DATE_DISCLAIMER_FOOTER, {
          startDate: startDate,
          endDate: endDate,
        }),
      ],
    },
  ],
  style: 'groupRow',
})

export const legalDisclaimerMarketConduct = ({ startDate, endDate }) => ({
  stack: [
    { text: MESSAGES.LEGAL_DISCLAIMER, style: 'title' },
    {
      ol: [
        MESSAGES.INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT_DETAIL,
        MESSAGES.PRELIMINARY_OFFER_MAY_CHANGE,
        Mustache.render(MESSAGES.DATE_DISCLAIMER_FOOTER, {
          startDate: startDate,
          endDate: endDate,
        }),
      ],
    },
  ],
  style: 'groupRow',
})

export const legalDisclaimerMarketConductNoAddtionalContract = ({ startDate, endDate }) => ({
  stack: [
    { text: MESSAGES.LEGAL_DISCLAIMER, style: 'title' },
    {
      ol: [
        MESSAGES.PRELIMINARY_OFFER_MAY_CHANGE,
        Mustache.render(MESSAGES.DATE_DISCLAIMER_FOOTER, {
          startDate: startDate,
          endDate: endDate,
        }),
      ],
    },
  ],
  style: 'groupRow',
})
